import { Component, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import { CurrentRechner } from '../../../shared/rechner';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-maintainance',
  templateUrl: './maintainance.component.html',
  styleUrls: ['./maintainance.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MaintainanceComponent implements OnInit {

  constructor(private currentRechner: CurrentRechner, private titleService: Title, private elemRef: ElementRef) { }

  ngOnInit() {
    this.titleService.setTitle('HDI - Wartungsarbeiten');
    this.currentRechner.setRechner('');
    this.currentRechner.setProduktseite('https://www.hdi.at');
    this.elemRef.nativeElement.querySelector('.maintainance-info').scrollTo(0, 0);
  }
}
